import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetTicketsBySearch(club, url) {

  var url = "/reservation/get_tickets_by_search/" + club + url; 

  return FetchGetDataWithAuthNEW(url);
}

